module.exports = __webpack_public_path__ + "static/steel-erecting-and-cladding-3-18e5140d9e0da41c063d18c8522dbe17.jpg";